/* BELLICO — mobile nav + variant swatches (cart handled by UpCart) */
(function(){
  document.addEventListener('DOMContentLoaded',function(){
    // mobile menu (Feetz-style: overlay below header, burger <-> X, sub-panels)
    var mm=document.querySelector('.mobile-menu');
    var header=document.querySelector('.header');
    var setMenuTop=function(){
      if(!mm||!header)return;
      var b=header.getBoundingClientRect().bottom;
      mm.style.setProperty('--header-bottom',Math.max(0,b)+'px');
      mm.style.top=Math.max(0,b)+'px';
    };
    var mmSetOpen=function(open){
      if(!mm)return;
      if(open)setMenuTop();
      mm.classList.toggle('open',open);
      mm.setAttribute('aria-hidden',open?'false':'true');
      document.body.classList.toggle('mm-open',open);
      document.querySelectorAll('[data-menu-toggle]').forEach(function(b){b.setAttribute('aria-expanded',open?'true':'false');});
      if(!open){
        mm.querySelectorAll('.mm-panel.mm-sub.active').forEach(function(p){p.classList.remove('active');});
        mm.querySelectorAll('[data-mm-sub]').forEach(function(b){b.setAttribute('aria-expanded','false');});
      }
    };
    document.querySelectorAll('[data-menu-toggle]').forEach(function(b){
      b.addEventListener('click',function(){mmSetOpen(!document.body.classList.contains('mm-open'));});
    });
    document.querySelectorAll('[data-menu-open]').forEach(function(b){b.addEventListener('click',function(){mmSetOpen(true);});});
    document.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',function(){mmSetOpen(false);});});
    if(mm){
      mm.querySelectorAll('[data-mm-sub]').forEach(function(b){
        b.addEventListener('click',function(){
          var p=mm.querySelector('[data-mm-panel="'+b.getAttribute('data-mm-sub')+'"]');
          if(p){p.classList.add('active');b.setAttribute('aria-expanded','true');}
        });
      });
      mm.querySelectorAll('[data-mm-back]').forEach(function(b){
        b.addEventListener('click',function(){
          var p=b.closest('.mm-panel');
          if(p)p.classList.remove('active');
          mm.querySelectorAll('[data-mm-sub]').forEach(function(t){t.setAttribute('aria-expanded','false');});
        });
      });
      mm.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mmSetOpen(false);});});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&document.body.classList.contains('mm-open'))mmSetOpen(false);});
      window.addEventListener('resize',function(){if(document.body.classList.contains('mm-open'))setMenuTop();});
      window.addEventListener('scroll',function(){if(document.body.classList.contains('mm-open'))setMenuTop();},{passive:true});
    }
    // variant swatches -> set hidden id input (so UpCart/checkout get the right variant)
    document.querySelectorAll('[data-variant]').forEach(function(sw){
      sw.addEventListener('click',function(){
        var group=sw.closest('.variant-row');
        group.querySelectorAll('[data-variant]').forEach(function(s){s.classList.remove('active');s.setAttribute('aria-pressed','false');});
        sw.classList.add('active');
        sw.setAttribute('aria-pressed','true');
        var input=document.querySelector('[name="id"]');
        if(input)input.value=sw.getAttribute('data-variant');
      });
    });

    // PDP quantity selector
    document.querySelectorAll('[data-qty-wrap]').forEach(function(w){
      var inp=w.querySelector('input[name="quantity"]');
      var minus=w.querySelector('[data-qty-minus]'),plus=w.querySelector('[data-qty-plus]');
      if(!inp)return;
      if(minus)minus.addEventListener('click',function(){inp.value=Math.max(parseInt(inp.min||'1',10),(parseInt(inp.value,10)||1)-1);});
      if(plus)plus.addEventListener('click',function(){inp.value=Math.min(parseInt(inp.max||'10',10),(parseInt(inp.value,10)||1)+1);});
    });

    // PDP image lightbox (zoom)
    var lb=document.querySelector('[data-lightbox]');
    if(lb){
      var lbImg=lb.querySelector('img');
      var lbOpen=function(src){if(!src)return;lbImg.src=src;lb.hidden=false;document.body.classList.add('lb-open');};
      var lbClose=function(){lb.hidden=true;lbImg.src='';document.body.classList.remove('lb-open');};
      document.querySelectorAll('img[data-full]').forEach(function(img){
        img.style.cursor='zoom-in';
        img.addEventListener('click',function(){lbOpen(img.getAttribute('data-full'));});
      });
      document.querySelectorAll('[data-zoom]').forEach(function(b){
        b.addEventListener('click',function(){
          var img=b.closest('.pdp-media')&&b.closest('.pdp-media').querySelector('img[data-full]');
          if(img)lbOpen(img.getAttribute('data-full'));
        });
      });
      lb.addEventListener('click',function(e){if(e.target===lb||e.target.closest('[data-lb-close]'))lbClose();});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!lb.hidden)lbClose();});
    }

    // sticky add-to-cart (mobile)
    var stickyBar=document.getElementById('stickyAtc');
    if(stickyBar){
      var pdpAddBtn=document.querySelector('.pdp-info [name="add"]');
      var sAdd=stickyBar.querySelector('[data-sticky-add]');
      if(sAdd&&pdpAddBtn){sAdd.addEventListener('click',function(){pdpAddBtn.click();});}
      if(pdpAddBtn&&'IntersectionObserver' in window){
        var sio=new IntersectionObserver(function(entries){entries.forEach(function(en){stickyBar.classList.toggle('show',!en.isIntersecting);});},{rootMargin:'0px 0px -40px 0px'});
        sio.observe(pdpAddBtn);
      }
    }

    // newsletter popup
    var ov=document.getElementById('np-overlay');
    if(ov){
      var posted=!!ov.querySelector('[data-np-success]');
      function npOpen(){ov.classList.add('open');}
      function npClose(){ov.classList.remove('open');try{localStorage.setItem('np_done','1');}catch(e){}}
      if(posted){npOpen();try{localStorage.setItem('np_done','1');}catch(e){}}
      else{var done;try{done=localStorage.getItem('np_done');}catch(e){}if(!done){setTimeout(npOpen,6000);}}
      ov.querySelectorAll('.np-close,[data-np-dismiss]').forEach(function(b){b.addEventListener('click',npClose);});
      ov.addEventListener('click',function(e){if(e.target===ov)npClose();});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&ov.classList.contains('open'))npClose();});
    }

    // hero carousel (swipe + counter/progress, click counter to advance)
    document.querySelectorAll('[data-hero-carousel]').forEach(function(track){
      var wrap=track.closest('.hero-carousel-wrap');
      if(!wrap)return;
      var counterBtn=wrap.querySelector('[data-hero-counter]');
      var counterText=wrap.querySelector('[data-hero-counter-text]');
      var progressFill=wrap.querySelector('[data-hero-progress]');
      var slides=track.querySelectorAll('.hero-slide');
      var total=slides.length;
      if(total<2)return;
      function update(){
        var idx=Math.round(track.scrollLeft/track.clientWidth);
        if(idx<0)idx=0;if(idx>total-1)idx=total-1;
        if(counterText)counterText.textContent=(idx+1)+' / '+total;
        if(progressFill)progressFill.style.width=((idx+1)/total*100)+'%';
        track.setAttribute('data-hero-index',idx);
      }
      track.addEventListener('scroll',function(){
        clearTimeout(track._heroT);
        track._heroT=setTimeout(update,80);
      },{passive:true});
      function goNext(){
        var idx=parseInt(track.getAttribute('data-hero-index')||'0',10);
        var next=(idx+1)%total;
        track.scrollTo({left:next*track.clientWidth,behavior:'smooth'});
      }
      if(counterBtn){
        counterBtn.addEventListener('click',function(){goNext();restartAutoplay();});
      }
      // autoplay (pauses on touch/hover, respects reduced motion)
      var autoplayMs=parseInt(track.getAttribute('data-hero-autoplay')||'0',10);
      var autoplayTimer=null;
      function startAutoplay(){
        if(!autoplayMs||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
        autoplayTimer=setInterval(function(){
          if(document.hidden)return;
          goNext();
        },autoplayMs);
      }
      function stopAutoplay(){if(autoplayTimer){clearInterval(autoplayTimer);autoplayTimer=null;}}
      function restartAutoplay(){stopAutoplay();startAutoplay();}
      ['pointerdown','touchstart'].forEach(function(ev){
        track.addEventListener(ev,restartAutoplay,{passive:true});
      });
      track.addEventListener('mouseenter',stopAutoplay);
      track.addEventListener('mouseleave',restartAutoplay);
      startAutoplay();
      update();
    });

    // ===== native cart drawer (v13) =====
    var cdRoot=document.querySelector('[data-cart-drawer-root]');
    function cdMoney(cents){
      var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
      var sym=cur==='USD'||cur==='AUD'||cur==='NZD'||cur==='CAD'?'$':cur==='GBP'?'£':'€';
      return sym+(cents/100).toFixed(2);
    }
    var cdLastFocus=null;
    function cdOpen(){
      if(!cdRoot)return;
      cdLastFocus=document.activeElement;
      cdRoot.classList.add('open');document.body.classList.add('cart-drawer-open');
      var panel=cdRoot.querySelector('.cart-drawer');
      if(panel)panel.focus();
      cdRecs();
    }
    function cdClose(){
      if(!cdRoot)return;
      cdRoot.classList.remove('open');document.body.classList.remove('cart-drawer-open');
      if(cdLastFocus&&cdLastFocus.focus)cdLastFocus.focus();
    }
    function cdBind(){
      if(!cdRoot)return;
      cdRoot.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',cdClose);});
      cdRoot.querySelectorAll('[data-cart-qty]').forEach(function(b){
        b.addEventListener('click',function(){
          if(b.disabled)return;
          cdRoot.querySelectorAll('[data-cart-qty]').forEach(function(x){x.disabled=true;});
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(b.getAttribute('data-cart-qty'),10),quantity:parseInt(b.getAttribute('data-qty'),10)})})
            .then(function(r){return r.json();}).then(function(c){cdRefresh();cdCount(c.item_count);})
            .catch(function(){cdRefresh();});
        });
      });
      var dIn=cdRoot.querySelector('[data-cart-discount-input]'),dBtn=cdRoot.querySelector('[data-cart-discount-apply]'),dMsg=cdRoot.querySelector('[data-cart-discount-msg]');
      if(dBtn){dBtn.addEventListener('click',function(){
        var code=(dIn.value||'').trim();if(!code)return;
        fetch('/discount/'+encodeURIComponent(code))
          .then(function(r){if(!r.ok)throw 0;if(dMsg){dMsg.textContent='Code entered — if valid, it will be applied at checkout.';dMsg.hidden=false;}})
          .catch(function(){if(dMsg){dMsg.textContent='Could not save the code — please enter it again at checkout.';dMsg.hidden=false;}});
      });}
    }
    function cdRefresh(){
      fetch(window.location.pathname+'?sections=cart-drawer').then(function(r){return r.json();}).then(function(j){
        var html=j['cart-drawer'];if(!html)return;
        var tmp=document.createElement('div');tmp.innerHTML=html;
        var fresh=tmp.querySelector('[data-cart-drawer-root]');
        if(fresh&&cdRoot){cdRoot.innerHTML=fresh.innerHTML;cdBind();cdRecs();}
      });
    }
    function cdCount(n){document.querySelectorAll('.cart-count').forEach(function(el){el.textContent='('+n+')';});}
    function cdRecs(){
      var box=cdRoot&&cdRoot.querySelector('[data-cart-recs]');if(!box)return;
      var pid=box.getAttribute('data-first-product');if(!pid)return;
      fetch('/recommendations/products.json?product_id='+pid+'&limit=4').then(function(r){return r.json();}).then(function(j){
        var prods=(j.products||[]).filter(function(p){return p.available;});
        if(!prods.length)return;
        var track=box.querySelector('[data-cart-recs-track]');
        track.innerHTML=prods.map(function(p){
          var img=p.featured_image||'';
          return '<div class="cd-rec"><a href="'+p.url+'"><img src="'+img+'" alt="" loading="lazy" width="120" height="120"><div class="cd-rec-title">'+p.title+'</div></a><div class="cd-rec-price">'+cdMoney(p.price)+'</div><button type="button" class="cd-rec-add" data-rec-add="'+p.variants[0].id+'">Add</button></div>';
        }).join('');
        box.hidden=false;
        track.querySelectorAll('[data-rec-add]').forEach(function(b){
          b.addEventListener('click',function(){
            fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(b.getAttribute('data-rec-add'),10),quantity:1})})
              .then(function(){return fetch('/cart.js');}).then(function(r){return r.json();}).then(function(c){cdRefresh();cdCount(c.item_count);});
          });
        });
      }).catch(function(){});
    }
    if(cdRoot){
      cdBind();
      document.querySelectorAll('a[href$="/cart"], a.cart-link').forEach(function(a){
        a.addEventListener('click',function(e){e.preventDefault();cdRefresh();cdOpen();});
      });
      document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
        f.addEventListener('submit',function(e){
          e.preventDefault();
          fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
            .then(function(r){if(!r.ok)throw 0;return fetch('/cart.js');})
            .then(function(r){return r.json();})
            .then(function(c){cdCount(c.item_count);cdRefresh();cdOpen();})
            .catch(function(){
              var m=f.querySelector('.atc-msg');
              if(!m){m=document.createElement('div');m.className='atc-msg';f.appendChild(m);}
              m.textContent='Sorry — this item could not be added. It may be sold out.';
            });
        });
      });
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&cdRoot.classList.contains('open'))cdClose();});
      cdRoot.addEventListener('keydown',function(e){
        if(e.key!=='Tab'||!cdRoot.classList.contains('open'))return;
        var f=cdRoot.querySelectorAll('button:not([disabled]),a[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
        if(!f.length)return;
        var first=f[0],last=f[f.length-1];
        if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
      });
    }

    // announcement daily countdown (resets at local midnight)
    var cdown=document.querySelector('[data-announce-countdown] b');
    if(cdown){
      var tickCd=function(){
        var n=new Date();
        var end=new Date(n.getFullYear(),n.getMonth(),n.getDate(),23,59,59);
        var s=Math.max(0,Math.floor((end-n)/1000));
        var h=String(Math.floor(s/3600)).padStart(2,'0'),m=String(Math.floor(s%3600/60)).padStart(2,'0'),x=String(s%60).padStart(2,'0');
        cdown.textContent=h+':'+m+':'+x;
      };
      tickCd();setInterval(tickCd,1000);
    }

    // announcement rotation
    var ann=document.querySelector('[data-announce]');
    if(ann){
      var amsgs=ann.querySelectorAll('.announce-msg');
      if(amsgs.length>1){
        var aidx=0;
        setInterval(function(){
          amsgs[aidx].classList.remove('is-active');
          aidx=(aidx+1)%amsgs.length;
          amsgs[aidx].classList.add('is-active');
        },4500);
      }
    }
  });
})();
